<script setup lang="ts">
const route = useRoute()

useHead({
  title: route.meta.title || "Postfinance",
  meta: [
    {
      name: "description",
      content: (route.meta.description as string) || "Postfinance"
    }
  ]
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
